import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.navigation.BasePath
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.navigation.remove
import com.varabyte.kobweb.silk.defer.DeferringHost
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.renderComposable
import io.noartcode.pages.HomePage as _io_noartcode_pages_HomePage

public fun main() {
    AppGlobals.initialize(mapOf("title" to "NoArtCode"))
    BasePath.set("")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.register(
            "/",
        ) { pageCtx -> 
            _io_noartcode_pages_HomePage()
        }

    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
        ctx.theme.registerStyle("top-navbar", io.noartcode.styles.TopNavbarStyle)
        ctx.theme.registerStyle("top-navbar-link", io.noartcode.styles.TopNavbarLinkStyle)
        ctx.theme.registerStyle("bottom-navbar-link", io.noartcode.styles.BottomNavbarLinkStyle)
        ctx.theme.registerStyle("primary-button", io.noartcode.styles.PrimaryButtonStyle)
        ctx.theme.registerStyle("secondary-button", io.noartcode.styles.SecondaryButtonStyle)
        ctx.theme.registerStyle("hero-section2-container", io.noartcode.styles.HeroSection2ContainerStyle)
        ctx.theme.registerStyle("hero-section-headline", io.noartcode.styles.HeroSectionHeadlineStyle)
        ctx.theme.registerStyle("hero-section2-subtitle", io.noartcode.styles.HeroSection2SubtitleStyle)
        ctx.theme.registerStyle("hero-section2-profile-image", io.noartcode.styles.HeroSection2ProfileImageStyle)
        ctx.theme.registerStyle("project-section-content", io.noartcode.styles.ProjectSectionContentStyle)
        ctx.theme.registerStyle("project-page-section", io.noartcode.styles.ProjectPageSectionStyle)
        ctx.theme.registerStyle("project-card2", io.noartcode.styles.ProjectCard2Style)
        ctx.theme.registerStyle("social-links", io.noartcode.styles.SocialLinksStyle)
        ctx.theme.registerStyle("about-me-image", io.noartcode.styles.AboutMeImageStyle)
        ctx.theme.registerStyle("page-section", io.noartcode.styles.PageSectionStyle)
        ctx.theme.registerStyle("page-section-arrow-link", io.noartcode.styles.PageSectionArrowLinkStyle)
        ctx.theme.registerStyle("contact-form", io.noartcode.styles.ContactFormStyle)
        ctx.theme.registerStyle("input", io.noartcode.styles.InputStyle)
        ctx.theme.registerStyle("text-area", io.noartcode.styles.TextAreaStyle)
        ctx.theme.registerStyle("experience-cards-container", io.noartcode.styles.ExperienceCardsContainerStyle)
        ctx.theme.registerStyle("experience-card", io.noartcode.styles.ExperienceCardStyle)
        ctx.theme.registerStyle("experience-page-section", io.noartcode.styles.ExperiencePageSectionStyle)
        ctx.theme.registerStyle("experience-card-link", io.noartcode.styles.ExperienceCardLinkStyle)
        ctx.theme.registerStyle("hero-section", io.noartcode.styles.HeroSectionStyle)
        ctx.theme.registerStyle("hero-content", io.noartcode.styles.HeroContentStyle)
        ctx.theme.registerStyle("hero-image", io.noartcode.styles.HeroImageStyle)
        ctx.theme.registerStyle("greeting-text", io.noartcode.styles.GreetingTextStyle)
        ctx.theme.registerStyle("hero-name-text", io.noartcode.styles.HeroNameTextStyle)
        ctx.theme.registerStyle("role-text", io.noartcode.styles.RoleTextStyle)
        ctx.theme.registerStyle("description-text", io.noartcode.styles.DescriptionTextStyle)
        io.noartcode.initStyles(ctx)
    }

    // Dedup any leading slashes after removing the origin, just in case someone typed
    // something like `https://site.com//about` by accident. If we pass `//about` into
    // `tryRoutingTo`, Kobweb will reject it as a protocol-relative URL; instead, we
    // want it to navigate to `/about`
    router.tryRoutingTo(BasePath.remove("/" + window.location.href.removePrefix(window.origin).trimStart('/')), UpdateHistoryMode.REPLACE)

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    val root = document.getElementById("_kobweb-root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    renderComposable(rootElementId = "_kobweb-root") {
        io.noartcode.AppEntry {
            router.renderActivePage { DeferringHost { it() } }
        }
    }
}
